import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { AlertTriangle, Info, AlertOctagon } from "lucide-react";

var API = "/api";
var POLL_INTERVAL_MS = 60000; // refresh every 60s so admins can change live without forcing reloads

function getSeverityStyle(sev) {
  if (sev === "critical") {
    return {
      bg: "bg-red-600",
      text: "text-white",
      Icon: AlertOctagon
    };
  }
  if (sev === "info") {
    return {
      bg: "bg-[#3a3a3a]",
      text: "text-white",
      Icon: Info
    };
  }
  // warning (default)
  return {
    bg: "bg-[#C0A062]",
    text: "text-black",
    Icon: AlertTriangle
  };
}

export default function AnnouncementBanner() {
  var [banner, setBanner] = useState(null);
  var bannerRef = useRef(null);

  useEffect(function() {
    function fetchBanner() {
      axios.get(API + "/site-settings/banner")
        .then(function(res) { setBanner(res.data); })
        .catch(function() {});
    }
    fetchBanner();
    var t = setInterval(fetchBanner, POLL_INTERVAL_MS);
    return function() { clearInterval(t); };
  }, []);

  // Publish banner height to a CSS variable so the navbar (and anything else)
  // can position itself just below the banner. Recalc on resize.
  useEffect(function() {
    var visible = banner && banner.enabled && banner.message;
    function updateHeight() {
      var h = (visible && bannerRef.current) ? bannerRef.current.offsetHeight : 0;
      document.documentElement.style.setProperty("--banner-height", h + "px");
    }
    updateHeight();
    if (visible) {
      window.addEventListener("resize", updateHeight);
      return function() {
        window.removeEventListener("resize", updateHeight);
        // Clean up when the banner is unmounted/hidden
        document.documentElement.style.setProperty("--banner-height", "0px");
      };
    }
    return undefined;
  }, [banner]);

  if (!banner || !banner.enabled || !banner.message) return null;

  var styling = getSeverityStyle(banner.severity);
  var Icon = styling.Icon;
  // Repeat the message for the marquee so it tiles smoothly across wide screens
  var msg = banner.message;

  return (
    <div
      ref={bannerRef}
      className={"fixed top-0 left-0 right-0 z-[60] overflow-hidden border-b border-black/20 " + styling.bg + " " + styling.text}
      data-testid="announcement-banner"
      role="alert"
    >
      <div className="relative flex overflow-x-hidden">
        <div className="animate-marquee whitespace-nowrap py-2 flex items-center">
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
        </div>
        <div className="absolute top-0 animate-marquee2 whitespace-nowrap py-2 flex items-center">
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
          <span className="mx-8 inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider">
            <Icon className="w-4 h-4" />
            {msg}
          </span>
        </div>
      </div>
    </div>
  );
}
